module.exports = __webpack_public_path__ + "img/9_d.86b4fba2.jpg";